<template>
  <navbar></navbar>
  <index-content></index-content>
</template>

<style lang="styl">
  body
    padding-top: 50px
    font-family: -apple-system-body,SFUI,Helvetica Neue,Helvetica,"Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif
</style>

<script>
  import Navbar from '../components/Navbar'
  import IndexContent from '../components/IndexContent'

  export default{
    name: 'IndexLayout',

    components: {
      Navbar,
      IndexContent
    }
  }
</script>



/** WEBPACK FOOTER **
 ** IndexLayout.vue?b04310ca
 **/